import type { DateKey } from '@/domain/date';
import type { Mark, PrayerId } from '@/domain/prayer';
import type { DayRecord } from '@/domain/streaks';

/**
 * The prayer record.
 *
 * Deliberately coarse: whole days in and out, no query language. A D1-backed
 * implementation maps `range` onto one SELECT over a (profile_id, date,
 * prayer) table and `setMark` onto one UPSERT, without any screen learning
 * that the data moved.
 */
export interface RecordsPort {
  day(date: DateKey): Promise<DayRecord>;
  range(from: DateKey, to: DateKey): Promise<DayRecord[]>;
  /** Rejects with {@link StorageError} when the record could not be kept. */
  setMark(date: DateKey, prayer: PrayerId, mark: Mark): Promise<void>;
}

/**
 * The record could not be stored — a full quota, a browser with site data
 * blocked, or later a request that never reached the server. Reading is allowed
 * to degrade to "nothing there"; writing is not allowed to pretend.
 */
export class StorageError extends Error {
  constructor() {
    super('the record could not be saved');
    this.name = 'StorageError';
  }
}
